import { Container, Row, Col } from 'react-bootstrap';

function Footer () {
    return <>
  <footer className="bg-dark text-light py-3 mt-auto">
      <Container>
        <Row className="text-center text-md-start">
          <Col xs={12} md={6} className="mb-2 mb-md-0">
            &copy;
             {new Date().getFullYear()} Decisive Devices Ltd
            <img className="m-2" src="/desiciveIcon.png"  width="4%" alt="Decisive Devices Ltd" />
          </Col>

        </Row>
      </Container>
    </footer>
    </>
}

export default Footer
